var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46506 14.988C2.1407 14.988 1.88121 14.8583 1.62172 14.6637C1.29736 14.3393 1.23249 13.8852 1.36224 13.496L2.01095 11.485C1.55685 10.5767 1.29736 9.5388 1.29736 8.50085C1.29736 4.9329 4.21659 2.01367 7.78454 2.01367C11.3525 2.01367 14.2717 4.9329 14.2717 8.50085C14.2717 12.0688 11.3525 14.988 7.78454 14.988C6.74659 14.988 5.70864 14.7285 4.80044 14.2744L2.78941 14.9232C2.72454 14.988 2.5948 14.988 2.46506 14.988ZM5.18967 12.977C5.96813 13.4311 6.87634 13.6906 7.78454 13.6906C10.6389 13.6906 12.9743 11.3552 12.9743 8.50085C12.9743 5.64649 10.6389 3.31111 7.78454 3.31111C4.93018 3.31111 2.5948 5.64649 2.5948 8.50085C2.5948 9.40906 2.85429 10.3173 3.30839 11.0957C3.37326 11.2255 3.43813 11.4201 3.37326 11.6147L2.72454 13.6257L4.73557 12.977C4.73557 12.977 5.12622 12.9453 5.18967 12.977Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78453 9.53879C8.35777 9.53879 8.82248 9.07408 8.82248 8.50084C8.82248 7.9276 8.35777 7.46289 7.78453 7.46289C7.21129 7.46289 6.74658 7.9276 6.74658 8.50084C6.74658 9.07408 7.21129 9.53879 7.78453 9.53879Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60582 9.53879C5.17906 9.53879 5.64377 9.07408 5.64377 8.50084C5.64377 7.9276 5.17906 7.46289 4.60582 7.46289C4.03258 7.46289 3.56787 7.9276 3.56787 8.50084C3.56787 9.07408 4.03258 9.53879 4.60582 9.53879Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9632 9.53879C11.5365 9.53879 12.0012 9.07408 12.0012 8.50084C12.0012 7.9276 11.5365 7.46289 10.9632 7.46289C10.39 7.46289 9.92529 7.9276 9.92529 8.50084C9.92529 9.07408 10.39 9.53879 10.9632 9.53879Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.1ee81e5b6e9aa3201648e2de24fd24b6.svg";
export { ForwardRef as ReactComponent };